"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORE_INVITE_STATUS = void 0;
exports.STORE_INVITE_STATUS = {
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    WAITING_RESPONSE: 'WAITING_RESPONSE',
    EXPIRED: 'EXPIRED'
};
//# sourceMappingURL=storeInviteStatus.js.map